<template>
    <div>
    	<div>
	        <Row class="expand-row">
	            <Col span="12">
	                <span class="expand-key">{{$t('smartMonitor.applicationSystemAlert.applicationName')}}: </span>
	                <span class="expand-value">{{ row.applicationName }}</span>
	            </Col>
	            <Col span="12">
	                <span class="expand-key">{{$t('smartMonitor.applicationSystemAlert.indexRating')}}: </span>
	                <span class="expand-value">{{ row.score.toFixed(2) }}</span>
	            </Col>
	        </Row>
	        <Row class="expand-row">
	        	<Col span="12">
	                <span class="expand-key">{{$t('smartMonitor.applicationSystemAlert.resourceType')}}: </span>
	                <span class="expand-value">{{ row.resourceTypeName }}</span>
	            </Col>
	            <Col span="12">
	                <span class="expand-key">{{$t('smartMonitor.applicationSystemAlert.indexFittingDegree')}}: </span>
	                <span class="expand-value">{{ row.fitting }}</span>
	            </Col>
	        </Row>
	        <Row class="expand-row">
	        	<Col span="12">
	                <span class="expand-key">{{$t('smartMonitor.applicationSystemAlert.resourceID')}}: </span>
	                <span class="expand-value">{{ row.resourceId }}</span>
	            </Col>
	            <Col span="12">
	                <span class="expand-key">{{$t('smartMonitor.applicationSystemAlert.predictionValue')}}: </span>
	                <span class="expand-value">{{ row.forecastValue }}</span>
	            </Col>
	        </Row>
	        <Row class="expand-row">
	        	<Col span="12">
	                <span class="expand-key">{{$t('smartMonitor.applicationSystemAlert.caseID')}}: </span>
	                <span class="expand-value">{{ row.ticketEntityId }}</span>
	            </Col>
	            <Col span="12">
	                <span class="expand-key">{{$t('smartMonitor.applicationSystemAlert.currentValue')}}: </span>
	                <span class="expand-value">{{ row.presentValue }}</span>
	            </Col>
	        </Row>
	        <Row class="expand-row">
	        	<Col span="12">
	                <span class="expand-key">{{$t('smartMonitor.applicationSystemAlert.index')}}: </span>
	                <span class="expand-value">{{ row.monitorName }}</span>
	            </Col>
	            <Col span="12">
	                <span class="expand-key">{{$t('smartMonitor.applicationSystemAlert.setIgnorance')}}: </span>
	                <span class="expand-value">{{ row.isIgnore }}</span>
	            </Col>
	        </Row>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            row: Object
        }
    };
</script>
<style scoped>
    .expand-row{
    	padding-left: 17px;
        margin-bottom: 10px;
    }
    .expand-key
    {
    	width: 145px;
    	display: block;
    	float: left;
    }
</style>



// WEBPACK FOOTER //
// src/components/ai_monitor/application_system_alarm/TableExpand.vue